export const willDevicesLimitBeExceeded = (
  numberToAdd: number,
  { current, limit }: TopologyLimit,
): boolean => {
  return numberToAdd + current > limit;
};
